module.exports = (promoCode) => `
  mutation {
    removePromotionFromCurrentOrder(promoCode: "${promoCode}") {
      number
      currency
      displayTotal
      promotionAdjustment {
        code
        amount
        currency
      }
    }
  }
`
